module.exports = __webpack_public_path__ + "img/excel_24px.4069eb7c.svg";